module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/28-b3dfa4eeeaba9a3690fce18c2d19c187.jpg";